import { render } from "./DetalleRuta.vue?vue&type=template&id=f3667eaa"
import script from "./DetalleRuta.vue?vue&type=script&lang=js"
export * from "./DetalleRuta.vue?vue&type=script&lang=js"

import "./DetalleRuta.vue?vue&type=style&index=0&id=f3667eaa&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__